import { Component, Input, OnInit, forwardRef } from '@angular/core';
import {
  ControlValueAccessor,
  FormControl,
  NG_VALUE_ACCESSOR,
  Validators,
} from '@angular/forms';
import { Subject } from 'rxjs';

@Component({
    selector: 'black-email-phone',
    templateUrl: './email-phone.component.html',
    styleUrls: ['./email-phone.component.css'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => EmailPhoneComponent),
            multi: true,
        },
    ],
    standalone: false
})
export class EmailPhoneComponent implements ControlValueAccessor, OnInit {
  @Input()
  isEmail = true;

  onChangeInput: Subject<string> = new Subject();

  public formControlEmail: FormControl = new FormControl('', {
    validators: [
      Validators.required,
      Validators.pattern('^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,4}$'),
    ],
  });
  public formControlPhone: FormControl = new FormControl('', {
    validators: [
      Validators.required,
      Validators.pattern('^(?:0|94|0094|\\+94)[0-9]{9}$'),
    ],
  });

  ngOnInit(): void {
    // onvalue change
    this.formControlEmail.valueChanges.subscribe((val) => {
      const isValid = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/.test(
        val
      );
      val = isValid ? val : '';
      this.onChangeInput.next(val);
    });
    this.formControlPhone.valueChanges.subscribe((val) => {
      const isValid = /^(?:0|94|0094|\\+94)[0-9]{9}$/.test(val);
      val = isValid ? val : '';
      this.onChangeInput.next(val);
    });
  }

  writeValue(value: any): void {
    if (this.isEmail) {
      this.formControlEmail.setValue(value);
    } else {
      this.formControlPhone.setValue(value);
    }
  }

  registerOnChange(fn: any): void {
    this.onChangeInput.subscribe((val) => fn(val));
  }

  registerOnTouched(fn: any): void {}

  changeInput(enabled: boolean) {
    this.isEmail = !enabled;
    this.formControlEmail.setValue('');
    this.formControlPhone.setValue('');
  }
}
